import { render, staticRenderFns } from "./footerMenu.vue?vue&type=template&id=19dfcb8e&"
import script from "./footerMenu.vue?vue&type=script&lang=js&"
export * from "./footerMenu.vue?vue&type=script&lang=js&"
import style0 from "./footerMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports